<div class="card-container">
  <div class="radio">
    Detect:
    <input id="hands" type="radio" name="model" value="hands"
           (change)="this.cameraService.model= this.uploadService.MODEL_HANDS" checked>
    <label for="hands">Hands</label>
    <input id="pose" type="radio" name="model" value="pose"
           (change)="this.cameraService.model= this.uploadService.MODEL_POSE">
    <label for="pose">Pose</label>
    <input id="face" type="radio" name="model" value="face"
           (change)="this.cameraService.model= this.uploadService.MODEL_FACE">
    <label for="face">Face</label>
  </div>
</div>

<div class="center" *ngIf="cameraService.loading || !mediaReady">
  <div class="loader"></div>
</div>
<div>
  <h3 class="center"> Video </h3>
  <video autoplay #localVideoElement
         id="localVideoElement"
         width="640" class="videoElementCSS"
         height="480"></video>
  <br/>
  <h3 class="center"> Canvas </h3>
  <canvas id="canvasLocalOutput" width="640"
          height="480" class="canvasElementCSS"
          #canvasLocalOutput>
  </canvas>
<!--  <div class="landmark-grid-container"></div>-->
</div>
